import { ApiLinkEntity, ApiLinkRel } from "config/constants"
import { Guid, IApiLink } from "@/types"
import ConnectedAsset from "./ConnectedAsset"

export interface IGetAssetCollectionDto {
    assets: Guid[]
    links?: IApiLink[]
}

interface IAssetCollection {
    assets: ConnectedAsset[]
    links?: IApiLink[]
}

export default class AssetCollection {
    assets: ConnectedAsset[]
    linkDelete?: IApiLink

    constructor(dto: IAssetCollection) {
        this.assets = dto.assets
        this.linkDelete = dto.links?.find(lnk => lnk.entity === ApiLinkEntity.assetCollection && lnk.rel === ApiLinkRel.delete)
    }
}
